// Words for the app's values, so the core holds no English. A port of
// packages/paidlark_core/lib/l10n/labels.dart.
import type { Greeting } from '@/core/dashboard';
import type { ClientSnapshot, Discount, InvoiceFilter, InvoiceStatus, PaymentMethod } from '@/core/invoice';
import { formatBasisPoints } from '@/core/money';
import { t } from '@/l10n/strings';

export const statusLabel = (status: InvoiceStatus) =>
  t({ draft: 'statusDraft', pending: 'statusPending', partiallyPaid: 'statusPartiallyPaid', paid: 'statusPaid', overdue: 'statusOverdue' }[status]);

export const templateLabel = (id: string) =>
  t(
    ({ classic: 'templateClassic', bold: 'templateBold', minimal: 'templateMinimal', modern: 'templateModern', elegant: 'templateElegant', sidebar: 'templateSidebar' } as Record<string, string>)[id] ??
      'templateClassic',
  );

export const paymentMethodLabel = (method: PaymentMethod) =>
  t({ bankTransfer: 'paymentBankTransfer', cash: 'paymentCash', pos: 'paymentPos', onlineLink: 'paymentLink', other: 'paymentOther' }[method]);

export const currencyLabel = (code: string) =>
  ({ NGN: t('currencyNgn'), USD: t('currencyUsd'), GBP: t('currencyGbp'), EUR: t('currencyEur'), GHS: t('currencyGhs'), KES: t('currencyKes'), ZAR: t('currencyZar') })[code] ?? code;

/** "Discount (5%)" or "Discount". */
export const discountLabel = (discount: Discount) =>
  discount.type === 'percent' ? t('discountLabelPercent', { percent: formatBasisPoints(discount.basisPoints) }) : t('discountLabel');

export const greetingLabel = (greeting: Greeting) => t({ morning: 'greetingMorning', afternoon: 'greetingAfternoon', evening: 'greetingEvening' }[greeting]);

export const filterLabel = (filter: InvoiceFilter) =>
  t({ all: 'filterAll', draft: 'filterDraft', pending: 'filterPending', overdue: 'filterOverdue', paid: 'filterPaid' }[filter]);

/** The client's name, or "No client yet" on a draft without one. */
export const clientNameLabel = (client: ClientSnapshot) => client.name.trim() || t('invoiceNoClientYet');
